import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FDStack } from '@facet-wealth/design';
import FileUploadDropArea from 'Components/ComponentLibrary/Molecules/FileUploadDropArea';
import fr from 'facet-rest';
import { AttachmentsList } from 'Organisms/AttachmentsList/AttachmentsList';
import { noop } from 'Helpers/PropTypes';

export default function FileUploadDropAreaWithAttachmentList({
  attachments,
  url,
  title,
  trailingTitleText,
  subtitle,
  acceptedFileTypes,
  multiple,
  confirmOnDelete,
  onSuccess,
  onError,
  errorMessage,
  onDelete,
  onUploadStart,
  onUploadEnd,
  uploadingState: uploadingStateProp,
}) {
  const [uploadProgress, setUploadProgress] = useState(0);
  const uploadingState = useState(false);

  // Prefer to use external uploading if available
  const [uploading, setUploading] = uploadingStateProp || uploadingState;

  const handleUploadStart = () => {
    setUploading(true);
    onUploadStart();
  };

  const handleUploadEnd = () => {
    setUploading(false);
    onUploadEnd();
  };

  return (
    <FDStack direction={'column'} spacing={2} align={'center'} width={'100%'}>
      {(multiple || !(uploading || attachments.length > 0)) && (
        <FileUploadDropArea
          title={title}
          trailingTitleText={trailingTitleText}
          subtitle={subtitle}
          url={url}
          onSuccess={onSuccess}
          onError={onError}
          errorMessage={errorMessage}
          acceptedFileTypes={acceptedFileTypes}
          multiple={multiple}
          setUploadProgress={setUploadProgress}
          onUploadStart={handleUploadStart}
          onUploadEnd={handleUploadEnd}
        />
      )}
      <AttachmentsList
        attachments={attachments}
        onDelete={onDelete}
        confirmOnDelete={confirmOnDelete}
        uploadProgress={uploadProgress}
        uploading={uploading}
      />
    </FDStack>
  );
}
FileUploadDropAreaWithAttachmentList.defaultProps = {
  title: undefined,
  trailingTitleText: 'files',
  attachments: [],
  acceptedFileTypes: undefined,
  multiple: false,
  confirmOnDelete: false,
  onSuccess: noop,
  onError: noop,
  errorMessage: undefined,
  onDelete: noop,
  subtitle: '',
  onUploadStart: noop,
  onUploadEnd: noop,
  uploadingState: undefined,
};
FileUploadDropAreaWithAttachmentList.propTypes = {
  attachments: PropTypes.arrayOf(fr.Resource),
  url: PropTypes.string.isRequired,
  acceptedFileTypes: PropTypes.arrayOf(PropTypes.string),
  multiple: PropTypes.bool,
  confirmOnDelete: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  trailingTitleText: PropTypes.string,
  subtitle: PropTypes.string,
  onSuccess: PropTypes.func,
  onError: PropTypes.func,
  errorMessage: PropTypes.string,
  onDelete: PropTypes.func,
  onUploadStart: PropTypes.func,
  onUploadEnd: PropTypes.func,
  uploadingState: PropTypes.array,
};
